module.exports = __webpack_public_path__ + "img/02.bb805367.jpg";